module.exports = __webpack_public_path__ + "img/network-bg.2d5afce5.jpg";